/**
 * Utility functions for handling article slugs
 */

// Generate URL-friendly slug from article title
export const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
};

// Get category path based on category name
export const getCategoryPath = (category) => {
  switch (category) {
    case "News":
      return "/news";
    case "TadReamk AI":
      return "/magazine/ai";
    case "TadReamk Design":
      return "/magazine/design";
    case "IP Law":
      return "/magazine/law";
    case "TadReamk-AIGC":
      return "/magazine/aigc";
    case "TadReamk-ERP":
      return "/magazine/erp";
    default:
      return "/news";
  }
};
